var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      class: { "nav-link": !_vm.scrolled },
      attrs: {
        href: _vm.urlWishList,
        rel: "nofollow",
        "aria-label": _vm.$translate("Ceres::Template.wishList")
      }
    },
    [
      _c("i", {
        staticClass: "fa",
        class: {
          "fa-heart-o": !_vm.wishListCount,
          "fa-heart": _vm.wishListCount
        },
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v(" "),
      !_vm.scrolled
        ? _c("span", {}, [
            _vm._v(_vm._s(_vm.$translate("Ceres::Template.wishList")))
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }